import React, {
	useState,
	useEffect
} from 'react'

import { useAuthSelector } from '../../services/selectors/authSelector';
import {
	shouldMaskPatientDetails,
	maskHeaderText,
} from '../../utils/helper/patientMasking';
import { getCurrentDateTimeInAppTimezone } from '../../utils/constants/timezone';

export const TopBar = () => {

	const { driverSelectedPharmacy, pharmacyId } = useAuthSelector()

	const getCurrentTimeCanada = () => {
		return getCurrentDateTimeInAppTimezone();
	}

	const DisplayCurrentTime = () => {
		const currentCanadaTime = getCurrentTimeCanada();
		setCurrentDateAndTime(currentCanadaTime);
	}
	const [currentDateAndTime, setCurrentDateAndTime] = useState(getCurrentTimeCanada);
	const shouldMaskHeader = shouldMaskPatientDetails(pharmacyId);
	const displayPharmacyName = shouldMaskHeader
		? maskHeaderText(driverSelectedPharmacy?.pharmacies?.name)
		: driverSelectedPharmacy?.pharmacies?.name?.toUpperCase();
	const displayPharmacyLocation = shouldMaskHeader
		? `${maskHeaderText(driverSelectedPharmacy?.pharmacies?.city)}${driverSelectedPharmacy?.pharmacies?.country ? `, ${maskHeaderText(driverSelectedPharmacy?.pharmacies?.country)}` : ''}`
		: `${driverSelectedPharmacy?.pharmacies?.city}, ${driverSelectedPharmacy?.pharmacies?.country}`;

	useEffect(() => {
		const interval = setInterval(DisplayCurrentTime, 1000);

		return () => clearInterval(interval);
	}, []);

	return (
		<>
			<div className="flex items-center gap-3">
				<div className="rounded-md flex items-center justify-center"
					style={{ width: '60px', height: '60px' }}>
					<img className='rounded-lg' src={driverSelectedPharmacy?.pharmacies?.logo_thumb_full_url
					} />
				</div>

				<div className="text-info">
					<h1 className="text-md font-bold">{displayPharmacyName}</h1>
					<p className="text-sm text-gray-500">{displayPharmacyLocation}</p>
					<p className="text-sm text-gray-500">{currentDateAndTime}</p>
				</div>
			</div>
			
		</>
	)
}


